export default __webpack_public_path__ + "static/bentoSectionBg3Mob-77e3c604464c4cfdba453c63226afdbb.webp";